var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":""}}):_c('div',{staticClass:"mt-2",attrs:{"id":"privacyPolicyContent"},domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.privacyPolicy))}})}
var staticRenderFns = []

export { render, staticRenderFns }